module.exports = ".input-errors {\n  margin: 1rem 0;\n  display: block;\n  padding: 1.4rem 1.125rem;\n  background-color: #fad37f;\n  border-radius: 5px;\n  font-weight: normal;\n  font-size: 1.4rem;\n  line-height: 1.5; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/form-input-error/form-input-error.component.scss
// module id = ./src/app/shared/form-input-error/form-input-error.component.scss
// module chunks = main